export const adminSiteLanes = (siteId: number | string) => `/admin/site/${siteId}/lane`;

export const adminSiteLane = (siteId: number | string, laneId: number | string) =>
  `/admin/site/${siteId}/lane/${laneId}`;

export const adminSiteLaneCustomerInitiatedAccessQr = (
  siteId: number | string,
  laneId: number | string,
) => `/admin/site/${siteId}/lane/${laneId}/customer-initiated-access/qr`;

export const adminSiteLaneGates = (siteId: number | string, laneId: number | string) =>
  `/admin/sites/${siteId}/lanes/${laneId}/gates`;

export const adminSiteLaneGate = (
  siteId: number | string,
  laneId: number | string,
  gateId: number | string,
) => `/admin/sites/${siteId}/lanes/${laneId}/gates/${gateId}`;

export const adminSiteLaneSignCode = (siteId: number | string, laneId: number | string) =>
  `/admin/sites/${siteId}/lanes/${laneId}/sign-code`;

export const adminLocationEquipment = (locationId: number | string) =>
  `/admin/location/${locationId}/equipment`;

export const adminLocationEquipmentById = (
  locationId: number | string,
  equipmentId: number | string,
) => `/admin/location/${locationId}/equipment/${equipmentId}`;

export const adminSiteDoors = (siteId: number | string) => `/admin/site/${siteId}/doors`;

export const adminSiteDoorOpen = (siteId: number | string, doorId: number | string) =>
  `/admin/site/${siteId}/doors/${doorId}/open`;

export const adminSiteDevices = (siteId: number | string) => `/admin/sites/${siteId}/devices`;

export const adminSiteDevice = (siteId: number | string, deviceUuid: string) =>
  `/admin/sites/${siteId}/devices/${deviceUuid}`;

export const ehcsDeviceUpdate = (deviceUuid: string) => `/ehcs/devices/${deviceUuid}/update`;
